import { gql } from '@apollo/client';

export const GET_TOP_PROVINCES = gql`
  query GetTopProvinces($filters: DistributionGraphsInput) {
    getTopProvinces(input: $filters) {
      amountOfListings
      label
    }
  }
`;
